import { render, staticRenderFns } from "./ProductAllocationCard.vue?vue&type=template&id=1907f7a4&scoped=true"
import script from "./ProductAllocationCard.vue?vue&type=script&lang=ts&scoped=true"
export * from "./ProductAllocationCard.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./ProductAllocationCard.vue?vue&type=style&index=0&id=1907f7a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907f7a4",
  null
  
)

export default component.exports